<script>
  import Rewards from '$components/locations/+rewards.svelte';
  import PaymentCards from '$components/locations/+paymentCards.svelte';
  import Tags from '$components/locations/+tags.svelte';
  import { modifyImageUrl, googleMapsUrl, calculateDaysRemaining } from '$utils/formatters';
  import Cashback from '$components/+cashback.svelte';

  /** @type {import('$types').PageData} */
  export let data;

  let layoutContent = data.layout.locations;

  $: geoPoint = data.geo_point?.coordinates ? googleMapsUrl(data.geo_point.coordinates) : '';
</script>

<div class="hero" style="background-image: url({modifyImageUrl(data.images?.hero)});">
  <Cashback cashback={data.rewards?.first_visit.rate} />
  <div class="logo">
    <img src={modifyImageUrl(data.images?.logo, { width: 200 })} alt={data.name} />
  </div>
  {#if data.end_date != null && data.show_end_date}
    <div class="time">
      <span>Kampagnen udløber om {calculateDaysRemaining(data.end_date)} dage </span>
    </div>
  {/if}
</div>
<div class="content">
  <h3>{data.name}</h3>
  {#if geoPoint && data.type == 'merchant'}
    <span class="address">
      <a href={geoPoint}> {data.addresses.physical.line1} - {data.addresses.physical.postcode} - {data.addresses.physical.city} </a>
    </span>
  {/if}

  <Tags types={layoutContent.types} {data} />

  {#if layoutContent.paymentCards.enabled}
    <PaymentCards paymentCardTypes={layoutContent.paymentCards.types} acceptedPaymentCardTypes={data.accepted_payment_types} />
  {/if}

  <Rewards reward_text={layoutContent.reward} rewards={data.rewards} cashbackLocationType={data.cashback_location_type} />

  <div class="description">
    {@html data.description}
  </div>

  <div class="button">
    <a href={data.addresses.virtual[0]?.url} size="xl" target="_blank">Gå til website</a>
  </div>
</div>
